<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-truck"
      texto-titulo="Listado de repartidores"
      :to-create-action="{ name: 'NuevoRepartidor' }"
      to-create-text="Nuevo repartidor"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList
          url="/repartidores"
          :fields="fields"
          :rowClick="mostrarOpciones"
          ref="datatable"
        ></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import Swal from "sweetalert2";
import axios from "axios";
import DataList from "@/components/layouts/DataList";
export default {
  name: "ListarRepartidores",
  components: {
    TituloComponent,
    DataList,
    BlockUI,
  },
  data() {
    return {
      repartidores: [],
      fields: [
        {
          name: "nombre",
          label: "",
          type: "title",
          class: "",
          value: null,
        },
      ],
      loading: false,
    };
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    mostrarOpciones(repartidor) {
      Swal.fire({
        title: repartidor.nombre,
        showCancelButton: true,
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
        confirmButtonColor: "#f7b924",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$router.push({
            name: "EditarRepartidor",
            params: { id: repartidor.id },
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.eliminarRepartidor(repartidor);
        }
      });
    },
    eliminarRepartidor(repartidor) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${repartidor.nombre} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/repartidores/" + repartidor.id)
            .then((res) => {
              Swal.fire(
                "Eliminado",
                `${res.data.repartidor.nombre} se ha eliminado con éxito.`,
                "success",
              );
              this.$refs.datatable.update();
            })
            .catch((err) => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
